import { Trophy, Users } from "lucide-react";
import { useAppContext } from "@/app/ContextProvider";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

/**
 * Liga + bajnokság választó. `stack` módban (mobil drawer) egymás alatt, teljes
 * szélességben; egyébként (fejléc) vízszintesen, fix szélességgel.
 */
export function ContextSwitcher({ className, stack = false }: { className?: string; stack?: boolean }) {
  const { leagues, tournaments, leagueId, tournamentId, setLeagueId, setTournamentId, isLoading } =
    useAppContext();

  const itemWidth = stack ? "w-full" : "w-36 xl:w-44";

  return (
    <div className={cn(stack ? "flex flex-col gap-2" : "flex items-center gap-2", className)}>
      <Select value={leagueId ?? undefined} onValueChange={setLeagueId} disabled={isLoading || leagues.length === 0}>
        <SelectTrigger className={itemWidth} aria-label="Liga">
          <Users className="size-4 shrink-0 text-muted-foreground" />
          <SelectValue placeholder="Liga" />
        </SelectTrigger>
        <SelectContent>
          {leagues.map((l) => (
            <SelectItem key={l.id} value={l.id}>
              {l.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select value={tournamentId ?? undefined} onValueChange={setTournamentId} disabled={isLoading || tournaments.length === 0}>
        <SelectTrigger className={itemWidth} aria-label="Bajnokság">
          <Trophy className="size-4 shrink-0 text-muted-foreground" />
          <SelectValue placeholder="Bajnokság" />
        </SelectTrigger>
        <SelectContent>
          {tournaments.map((t) => (
            <SelectItem key={t.id} value={t.id}>
              {t.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
